<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['agreements']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title']
            }),
            new fields.Input({
              label: 'Informacja',
              type: 'textarea',
              modelPath: [this, 'form', 'info']
            }),
            {
              component: 'h3',
              innerText: 'Zgody'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'agreements'],
              items: this.form.agreements.map((item, i) => ({
                headerLabel: i,
                fields: [
                  new fields.WYSIWYG({
                    label: 'Treść',
                    modelPath: [this, 'form', 'agreements', i, 'text'],
                    required: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
